import React from "react";

// Signature motif: "Roofline to floorplan". Decorative only, never a replacement for the logo.
type RooflineDividerProps = {
  className?: string;
};
export function RooflineDivider({
  className = ""
}: RooflineDividerProps) {
  return <div aria-hidden="true" className={`flex items-end ${className}`} data-id="element-591" data-mp="rend2v0jh1om">
      <span className="h-px flex-1 bg-current" data-id="element-592" data-mp="vfphdq9bc3xg" />
      <svg width="96" height="22" viewBox="0 0 96 22" fill="none" className="shrink-0" data-id="element-593" data-mp="vcbemgwqlsph">
        <path d="M0 21.5 L30 6 L44 14 L62 1 L96 21.5" stroke="currentColor" strokeWidth="1" data-id="element-594" data-mp="1j25qav5blb85" />
      </svg>
      <span className="h-px flex-1 bg-current" data-id="element-595" data-mp="1o18tsb5nj9e0" />
    </div>;
}